import { IRootState } from '../../../store'
import { IInitialAssessmentAirwayOptions } from '../store/options.types'

export const getInitialAssessmentAirwayOptionsSelector = (state: IRootState): IInitialAssessmentAirwayOptions =>
  state.options.assessmentAirwayOptions
